import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { markNewsletterSubscribed } from "@/lib/engagement";
import { verifyTurnstileToken } from "@/components/TurnstileWidget";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function useNewsletterSubscribe() {
  const [email, setEmail] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Honeypot — bots fill hidden fields. Silently "succeed".
    if (honeypot) {
      setDone(true);
      return;
    }

    if (!email.trim() || !EMAIL_REGEX.test(email.trim())) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    // CAPTCHA — verified server-side. In disabled mode (no secret configured)
    // verifyTurnstileToken returns true so this is a no-op until keys are added.
    const captchaOk = await verifyTurnstileToken(captchaToken);
    if (!captchaOk) {
      toast.error("Please complete the verification challenge.");
      setLoading(false);
      return;
    }

    const { error } = await supabase
      .from("newsletter_subscribers")
      .insert({ email: email.trim() });

    // Treat duplicate (23505) as success to prevent subscriber enumeration.
    if (error && error.code !== "23505") {
      toast.error("Failed to subscribe. Please try again.");
    } else {
      markNewsletterSubscribed();
      setDone(true);
      toast.success("Welcome to the council!");
    }
    setLoading(false);
  };

  return {
    email,
    setEmail,
    honeypot,
    setHoneypot,
    captchaToken,
    setCaptchaToken,
    loading,
    done,
    handleSubmit,
  };
}
